<template>
    <div id="adminBooking">
        <el-form
                :model="model"
                :rules="rules"
                label-width="150px"
                ref="form"
        >
            <el-form-item label="教室" prop="roomId">
                <el-select
                        @change="onChangeRoom"
                        filterable
                        placeholder="請選擇教室"
                        v-model="model.roomId"
                >
                    <el-option
                            :key="room.id"
                            :label="room.name + (room.isHidden ? '（已隱藏）' : '')"
                            :value="room.id"
                            v-for="room in rooms"

                    >
                    </el-option>
                </el-select>
                <el-button
                        @click="onShowInfo"
                        style="margin-left: 5px;"
                        type="info"
                >
                    檢視課表及借用情況
                </el-button>
            </el-form-item>
            <div>
                <el-row>
                    <el-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24">
                        <el-form-item label="日期選擇(多選)" prop="dates">
                            <v-date-picker
                                    :max-date="new Date(dateEnd)"
                                    :min-date="new Date()"
                                    @input="onDateSelect"
                                    is-inline
                                    mode="multiple"
                                    v-model="model.dates"
                            ></v-date-picker>
                        </el-form-item>

                    </el-col>
                    <el-col :lg="16" :md="14" :sm="24" :xl="16" :xs="24" v-if="formattedDates.length > 0">
                        <div style="margin-bottom: 10px;">
                            節次選擇
                            <el-button
                                    @click="onCancelAll"
                                    icon="el-icon-refresh-right"
                                    size="mini"
                                    type="warning"
                            >
                                重設
                            </el-button>
                        </div>
                        <p>
                        ※週一至週五中午時段(12:10~13:00)為第16節
                        </p>

                        <div style="max-height: 300px; overflow-y: auto; ">
                            <el-form-item
                                    :key="d"
                                    :label="`${d}:`"
                                    :prop="d"
                                    v-for="d in formattedDates"

                            >
                                <period-picker
                                        :comparer="(b, e) => e >= b"
                                        :options="periodOpt"
                                        @endChange="v => onEndChange(v, d)"
                                        @beginChange="v => onBeginChange(v, d)"
                                        v-model="model[d]"
                                ></period-picker>
                                <el-button
                                        @click="onCancelDate(d)"
                                        style="margin-left: 2px;"
                                        type="danger"
                                >
                                    取消
                                </el-button>
                            </el-form-item>
                        </div>

                    </el-col>
                </el-row>
            </div>
            <el-form-item prop="reason" label="事由" :rules="[{required:false}]">
                <el-input
                        placeholder="請輸入事由(選填)"
                        style="width: 300px;"
                        type="textarea"
                        v-model="model.reason"
                ></el-input>
            </el-form-item>
        </el-form>
        <el-button
                :loading="loading.actions['booking']"
                @click="submit"
        >
            送出
        </el-button>
        <el-dialog
                :title="queryTitle"
                :visible.sync="show"
                top="5vh"
                width="80%"
        >
            <TimetableQueryOfOneRoom :selected-room-id='model.roomId'
                                     ref="timetableQuery"
                                     @cell-click="onCellClick"
            ></TimetableQueryOfOneRoom>
            <template #footer>
                <el-button @click="show=false">關閉</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import PeriodPicker from '../PeriodPicker';
    import BookingMixin from '../../bookingMixin';
    import TimetableQueryOfOneRoom from '../Booking/TimetableQueryOfOneRoom';
    import moment from 'moment';

    export default {
        name: 'AdminBooking',
        components: {
            PeriodPicker,
            TimetableQueryOfOneRoom
        },
        mixins: [BookingMixin],
        data: () => ({}),
        computed: {
            ...mapState('manage', ['bookingParams']),
        },
        methods: {
            ...mapActions('booking', {
                book: 'adminSubmitAction',
            }),
            ...mapActions('setting', {
                getWeekRanges: 'getWeekRangesAction'
            }),

            async submit() {
                const {form} = this.$refs;

                await form.validate(async (valid) => {
                    if (valid) {
                        const periods =
                            Object.keys(this.model)
                                .filter(d => moment(d, 'YYYY-MM-DD').isValid())
                                .reduce((ary, key) => ([...ary, {
                                    date: key,
                                    begin: this.model[key][0],
                                    end: this.model[key][1]
                                }]), [])
                        ;
                        const {success, messages = []} = await this.book({
                            userId: this.userId,
                            schoolYear: this.schoolYear,
                            semester: this.semester,
                            periods,
                            roomId: this.selectedRoom.ncutRoomId,
                            reason: this.model.reason
                        });

                        if (success) {
                            this.$message.success('登記成功!');
                            this.reset();
                            this.model.roomId = this.rooms[0].id;
                            const {form, timetableQuery} = this.$refs;
                            if (timetableQuery) {
                                await timetableQuery.refresh();
                            }
                            if (form) {
                                form.clearValidate();
                            }

                        } else {
                            this.$message.warning(messages.join(','));
                        }

                    } else {
                        this.$message({
                            type: 'warning',
                            message: '您還有欄位尚未輸入!!'
                        });
                    }
                });
            },
        },
        watch: {
            rooms(current) {
                this.model.roomId = (current || [{id: ''}])[0].id;
            },
            reasonType() {
                this.model.reason = '';
            },

            bookingParams(current) {
                if (current
                    && current.roomId
                    && current.periods
                    && current.periods.length > 0
                    && current.date) {
                    const {roomId, periods = [], date, reason=''} = current;
                    this.reset();
                    this.model.roomId = roomId;
                    this.model.dates = [...this.model.dates, new Date(date)];
                    this.model = {...this.model, [date]: periods};
                    this.model.reason = reason;
                    if (this.$refs.form) {
                        this.$refs.form.clearValidate();
                    }
                }
            },
            async schoolYear(current) {
                const {semester} = this;
                await this.getWeekRanges({
                    schoolYear: current,
                    semester
                });
            }
        },

        async created() {
            const {schoolYear, semester} = this;
            this.model.realUserId = this.userId;
            await this.getCourses(this.userId);
            if (this.rooms && this.rooms.length > 0) {
                this.model.roomId = this.rooms[0].id;
            }
            if (schoolYear) {
                await this.getWeekRanges({
                    schoolYear,
                    semester
                });
            }
        }
    }
</script>

<style>
    #adminBooking .el-input__inner {
        min-width: 200px;
        max-width: 200px;
    }

    #adminBooking .reason .el-input__inner {
        max-width: 300px;
    }
</style>
